import { Slot } from '@radix-ui/react-slot'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

export const ChangePricingCampaignsPriority = ({
	children,
	globalPcSetId,
}: {
	children: React.ReactNode
	globalPcSetId: string
}) => {
	const { showModal } = useModals()

	const hanldeChangePriority = () => {
		ampli.settingsPricingCampaignsReorderClick({
			location: 'table-group-header',
		})
		showModal('PRICING_CAMPAIGNS_PRIORITY', {
			globalPcSetId,
		})
	}

	return <Slot onClick={hanldeChangePriority}>{children}</Slot>
}
